import React from 'react';
import { motion } from 'framer-motion';
import { FullCaseDetails } from '../../../../interfaces/cliente.types';
import styles from './InfoCard.module.css';
import { User, Award, Phone, Mail, MapPin, FileText, Landmark, FileSignature, Hash, CalendarDays } from 'lucide-react';

interface CasoInfoCardProps {
    caso: FullCaseDetails;
}

const InfoBlock: React.FC<{ icon: React.ElementType, label: string, value?: string | number | null }> = ({ icon: Icon, label, value }) => {
    if (!value) return null;

    return (
        <div className={styles.infoBlock}>
            <div className={styles.iconWrapper}>
                <Icon size={24} />
            </div>
            <div className={styles.infoText}>
                <span className={styles.infoLabel}>{label}</span>
                <span className={styles.infoValue}>{value}</span>
            </div>
        </div>
    );
};

export const CasoInfoCard: React.FC<CasoInfoCardProps> = ({ caso }) => {
    
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.07,
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 20, transition: { type: 'spring', stiffness: 100 } }
    };

    const formatDate = (dateString: string | null | undefined) => {
        if (!dateString) return null;
        return new Date(dateString + 'T00:00:00').toLocaleDateString('es-PE', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    return (
        <motion.div 
            className={styles.card}
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="hidden"
        >
            <header className={styles.cardHeader}>
                <div className={styles.headerInfo}>
                    <h2 className={styles.clientName}>{caso.nombre_completo}</h2>
                    <p className={styles.caseType}>{caso.tipo_caso}</p>
                </div>
                <div className={`${styles.statusBadge} ${styles[`status${caso.estado_caso.replace(' ', '')}`]}`}>
                    {caso.estado_caso}
                </div>
            </header>
            
            <div className={styles.infoGrid}>
                <InfoBlock icon={Award} label="DNI" value={caso.dni} />
                <InfoBlock icon={Phone} label="Teléfono" value={caso.telefono} />
                <InfoBlock icon={Mail} label="Email" value={caso.email} />
               
                <InfoBlock icon={Hash} label="N° Expediente" value={caso.numero_expediente} />
                <InfoBlock icon={Landmark} label="Juzgado" value={caso.juzgado} />
                <InfoBlock icon={MapPin} label="Lugar del Proceso" value={caso.lugar} />
                <InfoBlock icon={FileText} label="Dirección del Cliente" value={caso.direccion} />
            </div>
        </motion.div>
    );
};